module.exports = __webpack_public_path__ + "img/nav.149adda6.png";